<template>
  <div class="currency-amount-wrapper">
    <template v-if="amount !== null">
      <span class="currency-amount" :style="'font-size:' + amountFontSize + 'px'">{{ formattedAmount }}</span>
      <span v-if="currency && !hideCurrency" class="currency-name" :style="'font-size:' + currencyFontSize + 'px'">{{ currency }}</span>
    </template>
    <template v-else>-</template>
  </div>
</template>

<script>
import {LocaleUtils} from '../utils/locale-utils';
import config from '../properties';

export default {
  name: 'CurrencyAmount',
  mixins: [
    LocaleUtils
  ],
  props: {
    amount: {
      type: Number
    },
    currency: {
      type: String,
      default: config.defaultCurrency
    },
    hideCurrency: {
      type: Boolean
    },
    amountFontSize: {
      type: Number,
      default: null
    },
    currencyFontSize: {
      type: Number,
      default: null
    },
    precision: {
      type: Number,
      default: undefined
    }
  },
  computed: {
    formattedAmount () {
      return this.renderCurrencyAmount(this.amount, this.currency, false, this.precision);
    }
  }
};
</script>

<style scoped lang="scss">
.currency-amount-wrapper {

  .currency-name {
    color: #777;
    margin-left: 0.4rem;
    font-size: 0.8em;
  }
}
</style>
